import React from 'react';

import { useBillingInformationQuery } from '@edx/graphql/generated';
import { IconCheck, IconClose } from '@edx/components/icons';
import { Body, Intro, Title } from '@edx/components/typography';
import EDBLogo from '@edx/img/edb-logo.svg';

export const PricingComparison: React.FC = () => {
  const { data } = useBillingInformationQuery();
  const [, , yearlyPlan] = data?.billingInformation.plans || [];

  return (
    <section className="text-gray-500 grid grid-cols-12">
      <div className="col-span-full col-start-1 lg:col-span-8 lg:col-start-3 md:px-4 px-0">
        <table className="w-full">
          <thead className="border-b border-gray-600 border-opacity-50">
            <tr>
              <th className="pb-6">&nbsp;</th>
              <th className="pb-6 w-auto flex justify-center">
                <img src={EDBLogo} alt="" className="w-10 md:w-16" />
              </th>
              <th className="pb-6 w-auto px-0 md:px-8">
                <Intro tag="h2" size="small" className="md:text-intro text-gray-400 leading-tight">
                  Clases <br /> Particulares
                </Intro>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-600 divide-opacity-50">
            <tr>
              <th className="py-4 text-left">
                <Body size="small" variant="semibold" className="md:text-body md:font-normal">
                  Aprende dónde y cuándo quieras
                </Body>
              </th>
              <td className="py-4">
                <IconCheck className="text-gray-300 mx-auto" />
              </td>
              <td className="py-4">
                <IconClose className="mx-auto" />
              </td>
            </tr>
            <tr>
              <th className="py-4 text-left">
                <Body size="small" variant="semibold" className="md:text-body md:font-normal">
                  Profesores de primera linea
                </Body>
              </th>
              <td className="py-4">
                <IconCheck className="text-gray-300 mx-auto" />
              </td>
              <td className="py-4">
                <IconClose className="mx-auto" />
              </td>
            </tr>
            <tr>
              <th className="py-4 text-left">
                <Body size="small" variant="semibold" className="md:text-body md:font-normal">
                  Seguimiento del progreso
                </Body>
              </th>
              <td className="py-4">
                <IconCheck className="text-gray-300 mx-auto" />
              </td>
              <td className="py-4">
                <IconClose className="mx-auto" />
              </td>
            </tr>
            <tr>
              <th className="py-4 text-left">
                <Body size="small" variant="semibold" className="md:text-body md:font-normal">
                  Repite tantas veces como necesites
                </Body>
              </th>
              <td className="py-4">
                <IconCheck className="text-gray-300 mx-auto" />
              </td>
              <td className="py-4">
                <IconClose className="mx-auto" />
              </td>
            </tr>
            <tr>
              <th className="py-4 text-left">
                <Body size="small" variant="semibold" className="md:text-body md:font-normal">
                  Comunidad participativa
                </Body>
              </th>
              <td className="py-4">
                <IconCheck className="text-gray-300 mx-auto" />
              </td>
              <td className="py-4">
                <IconClose className="mx-auto" />
              </td>
            </tr>
          </tbody>
          <tfoot className="border-gray-600 border-opacity-50 border-t">
            <tr>
              <th>
                <Intro size="small" className="md:text-intro text-gray-400 text-left">
                  Inversión total
                </Intro>
              </th>
              <td className="py-4 text-center">
                <Title tag="span" className="text-gray-300 leading-tight">
                  {yearlyPlan?.priceFormatted || '\u00a0'}
                </Title>
                <br />
                <Body tag="span">/ año</Body>
              </td>
              <td className="py-4 text-center">
                <Title tag="span" className="tutorial-amount relative leading-tight">
                  {data?.billingInformation?.yearlyEstimationFormatted || '\u00a0'}
                </Title>
                <br />
                <Body tag="span">/ año</Body>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </section>
  );
};
